export const DateTimeFormats = {
    // for instances, supposed it's `Thursday, January 16, 2020 8:21:08 PM (01/16/2020)`
    DateMed: 'll', // 'Jan 16, 2020'
    DateTime: 'YYYY-MM-DD HH:mm:ss', // 2020-01-16 20:21:08
    DateTimeHumanReadable: 'MMM. D, YYYY HH:mm', // Jan. 6, 2020 20:21
    DateTimeNoSec: 'YYYY-MM-DD HH:mm', // 2020-01-16 20:21
    Date: 'YYYY-MM-DD', // 2020-01-16
    DateHumanReadable: 'MMMM DD, YYYY', // January 16, 2020
    DateHumanReadableShortMonth: 'MMM DD, YYYY', // Jan 16, 2020
    Time: 'HH:mm:ss', // 20:21:08
    HourMinute: 'HH:mm', // 20:21
    WeekDayShortName: 'ddd', // Thu
    MonthNameWithYear: 'MMMM YYYY', // January 2020
    MonthShortNameWithYear: 'MMM. YYYY', // Jan. 2020
    MonthShortNameWithDay: 'MMM DD', // Jan 16
    MonthShortNameWithOrdinalDay: 'MMM. Do', // Jan. 16th
    MonthNameWithDay: 'MMMM DD', // January 16
    MonthFullName: 'MMMM', // January
    FullYear: 'YYYY', // 2020
    Day: 'DD', // 03
    DayWeek: 'DD ddd', // 16 Thu
    WeekDayWithDate: 'dddd MMM DD', // Thursday Jan 16
    WeekDayShortWithDate: 'ddd MMM DD', // Thu Jan 16
    WeekDayWithOrdinalDay: 'ddd. Do', // Thu. 16th
    WeekDayWithOrdinalDayWithComma: 'ddd, Do', // Thu. 16th
    DateInLocale: 'L', // 01/16/2020 (localized format)
    TimeInLocale: 'LT', // 8:21 PM (localized format)
    FullDateTimeLocaleActivitySessions: 'MMM DD, YYYY HH:mm', // Jan 16, 2020 08:21
    AdherenceReportApiModifiedDateFormat: 'MMM-DD-YYYY HH:mm', // Jan-16-2020 08:21
    HourMinuteMeridiemWithSeparator: 'hh:mm|A', // 08:21|PM
    DateHumanReadableWithSeparator: 'MMMM|D|YYYY', // January 16, 2020
    DateHourMinuteMeridiem: 'YYYY-MM-DD hh:mm A', // 2020-01-16 08:21 PM
    MonthDay: 'M/D', // 1/16
} as const;

export const TimeZones = {
    EtcUTC: 'Etc/UTC',
} as const;

export const MONTHS_FULL_NAME = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
] as const;

export const MONTHS_SHORT_NAME = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] as const;
